import * as Styles from './styles'

const PromotionalBanner = ({ imageUrl, url, borderRadius = '32px' }) => {
  if (!imageUrl) return null

  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <Styles.Image src={imageUrl} borderRadius={borderRadius} />
    </a>
  )
}

export default PromotionalBanner
